export default __webpack_public_path__ + "media/images/amenities/hairdryer-bd83fb489dd50291b8722f1763730202.jpeg";